(function () {
    class HorizontalTabs extends HTMLElement {
        constructor() {
            super();
            const self = this;
            this.sectionId = this.getAttribute('data-id');
            this.sectionElement = document.getElementById(`horizontal-tabs-${this.sectionId}`);
            this.videoActions = this.sectionElement?.querySelectorAll('.media-with-text-video-actions');
            this.videoActions.forEach(ac => ac.addEventListener('click', this.onClickVideoAction.bind(this)));
            this.popupVideoContainer = this.sectionElement?.querySelector('.media-popup-video__container');
            this.openFirstTab = this.getAttribute('data-open-first-tab');
            this.tabElement = this.querySelector('tabs-element');
            this.accordionElement = this.querySelector('.horizontal-tab-accordion');
            this.mediaVideo = this.querySelector('.media-with-text-video');
            
            if (this.mediaVideo) this.mediaVideo.addEventListener('click', this.onClickVideo.bind(this));
            self.init();

            document.addEventListener('shopify:block:select', function (event) {
                const target = event.target;
                const clientWidth = Math.round(document.body.clientWidth);
                const blockId = target.getAttribute('data-id');
                const sectionElement = target.closest('.horizontal-tabs-section');
                
                if (clientWidth < 750) {
                  const accordion = target.querySelector('details');
                  if (accordion) accordion.setAttribute('open', '');
                } else {
                  const tabsTitle = sectionElement?.querySelectorAll('.tabs-actions .tab-title') || [];
                  const tabsContent = sectionElement?.querySelectorAll('.tabs-content .tab-content') || [];
                  const blockTabId = `${blockId}`;
                  
                  tabsTitle.forEach((title) => {
                    for (let index = 0; index < tabsTitle.length; index++) {
                      const element = tabsTitle[index];
                      const elementId = element.getAttribute('data-id');
                      if (elementId.trim() == blockTabId.trim()) {
                        element.classList.add('tab-active');
                      } else {
                        element.classList.remove('tab-active');
                      }
                    }
                    for (let index = 0; index < tabsContent.length; index++) {
                      const element = tabsContent[index];
                      const elementId = element.getAttribute('data-id');
          
                      if (elementId.trim() == blockTabId.trim()) {
                        element.classList.add('tab-active');
                      } else {
                        element.classList.remove('tab-active');
                      }
                    }
                  });
                }
            });
        }

        init() {
          const clientWidth = Math.round(document.body.clientWidth);
          if (clientWidth > 749) {
            const tabTitles = this.tabElement?.querySelectorAll('.tab-title');
            const tabContents = this.tabElement?.querySelectorAll('.tabs-content .tab-content');
            if (tabTitles.length > 0) {
              tabTitles[0].classList.add('tab-active');
            }
            if (tabContents.length > 0) {
              tabContents[0].classList.add('tab-active');
            }
          } else {
            if (this.openFirstTab == 'true') {
              const accordions = this.accordionElement?.querySelectorAll('.accordion details') || [];
              if (accordions.length > 0) {
                accordions[0].setAttribute('open', '');
              }
            }
          }
          this.tabElement?.addEventListener('tabChanged', this.onTabChange.bind(this));
        }

        onClickVideo() {
          if (!this.mediaVideo.getAttribute('data-play') || this.mediaVideo.getAttribute('data-play') == 'pause') {
            return;
          }
          this.mediaVideo.setAttribute('data-play', 'pause');
          this.media = this.mediaVideo.querySelector('video, iframe, model-viewer');
          const handleMedia = new HandleMedia(this.media);
          handleMedia.pause();
        }

        onClickVideoAction(e) {
            e.preventDefault();
            e.stopPropagation();
            const target = e.target.closest('.media-with-text-video-actions');
            if (!target) {
                return
            }
            const videoContainer = e.target.closest('.media-with-text-video');
            const videoFrame = videoContainer?.querySelector('.media-with-text-video-frame');
            if (!videoContainer) return;
            if (videoContainer.getAttribute('data-popup') == 'true') {
                const videoFrameClone = videoFrame.cloneNode(true);
                const iframe = videoFrameClone.querySelector('iframe');
                if (iframe) {
                  iframe.id = iframe.id + '-popup';
                  const iframeSrc = iframe.getAttribute('src').replace('autoplay=0', 'autoplay=1');
                  iframe.setAttribute('src', iframeSrc);
                }

                if (this.popupVideoContainer) this.popupVideoContainer.innerHTML = videoFrameClone.innerHTML;
                setTimeout(() => {
                  const video = this.popupVideoContainer.querySelector('video');
                  if (video) {
                    video.play();
                  }
                }, 500);
                return;
            }
            const action = videoContainer.getAttribute('data-play');
            const video = videoFrame?.querySelector('.video') || videoFrame?.querySelector('video');
            if (action == 'pause') {
            videoContainer.setAttribute('data-play', 'play');
            if (video.classList.contains('js-vimeo')) {
                video.contentWindow.postMessage('{"method":"play"}', '*');
            } else if (video.classList.contains('js-youtube')) {
                video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } else {
                video.play();
            }
            } else {
            if (video.classList.contains('js-vimeo')) {
                video.contentWindow.postMessage('{"method":"pause"}', '*');
            } else if (video.classList.contains('js-youtube')) {
                video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            } else {
                video.pause();
            }
            videoContainer.setAttribute('data-play', 'pause');
            }

            
        }

        onTabChange(e) {
          const tabId = e.detail.tabId;
          const target = e.detail.target;
          if (target.getAttribute('data-type') == 'tab-media_with_text') {
            const imageContentGrid = this.querySelectorAll('image-content-grid');
            imageContentGrid.forEach(element => {
              element.init();
            });
          }
        }
    }
    if (!customElements.get('horizontal-tabs-section')) { customElements.define('horizontal-tabs-section', HorizontalTabs); }
})();